import { Tag as PrimitiveTag } from '@latitude/tag';
import type { ComponentProps } from 'react';

/**
 * Renders a tag component.
 *
 * @component
 * @example
 * ```tsx
 * <Tag>
 *   Example Tag
 * </Tag>
 * ```
 */
export const Tag = ({
  children,
  noShrink,
  ...props
}: ComponentProps<typeof PrimitiveTag> & { noShrink?: boolean }) => {
  return (
    <div
      style={{
        maxWidth: '200px',
        display: 'inline-flex',
        flexShrink: noShrink ? 0 : 1,
        minWidth: 0,
      }}
    >
      <PrimitiveTag
        variant="neutral"
        size="tiny"
        fill="filled"
        data-testid="select-chip"
        className="max-w-full"
        spanProps={{
          className: 'block',
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
          },
        }}
        rawProps={{
          style: {
            maxWidth: '100%',
          },
        }}
        {...props}
      >
        {children}
      </PrimitiveTag>
    </div>
  );
};
